import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const REASONS = [
  "Penipuan",
  "Konten tidak pantas",
  "Informasi pekerjaan tidak sesuai",
  "Perilaku mencurigakan",
  "Lainnya",
];

export function ReportModal({ open, onOpenChange, targetUserId, targetJobId }) {
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!reason) return toast.error("Pilih alasan laporan");
    setLoading(true);
    try {
      await api.post("/reports", {
        target_user_id: targetUserId || null,
        target_job_id: targetJobId || null,
        reason,
        description,
      });
      toast.success("Laporan terkirim. Terima kasih.");
      setReason(""); setDescription("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="report-modal">
        <DialogHeader>
          <DialogTitle>Laporkan</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Alasan</label>
            <Select value={reason} onValueChange={setReason}>
              <SelectTrigger data-testid="report-reason-select"><SelectValue placeholder="Pilih alasan" /></SelectTrigger>
              <SelectContent>
                {REASONS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Deskripsi (opsional)</label>
            <Textarea
              data-testid="report-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Jelaskan masalahnya..."
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button data-testid="report-submit" onClick={submit} disabled={loading} className="bg-rose-600 hover:bg-rose-700">
            {loading ? "Mengirim..." : "Kirim Laporan"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
